function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M814 2379c-433.199 0-814-328.37-814-742.1 0-252.85 125.774-456.43 363.331-574.64-136.248-124.781-216.6-249.561-216.6-433.444 0-166.772 70.486-326.713 195.951-444.639C468.147 66.25 638.316 0 815.753 0c177.428 0 347.597 66.25 473.067 184.177 125.46 117.926 195.95 277.867 195.95 444.639 0 183.883-83.84 308.663-220.09 433.444C1502.24 1180.47 1628 1384.05 1628 1636.9c-3.49 413.73-380.79 742.1-814 742.1zm0-1093.45c-73.929 0-146.205 20.6-207.679 59.21-61.465 38.6-109.385 93.48-137.674 157.68s-35.693 134.84-21.276 203c14.426 68.15 50.028 130.76 102.309 179.9 52.281 49.13 118.888 82.6 191.399 96.16 72.512 13.56 147.668 6.6 215.973-20 68.308-26.59 126.688-71.63 167.758-129.41 41.08-57.77 63-125.7 63-195.19-.09-93.17-39.5-182.47-109.58-248.35-70.09-65.87-165.11-102.92-264.23-103zm0-896.435c-51.472-.327-101.891 13.705-144.887 40.314-42.988 26.61-76.618 64.601-96.64 109.183-20.013 44.573-25.518 93.722-15.816 141.238 9.702 47.515 34.184 91.262 70.331 125.7 36.156 34.447 82.369 58.037 132.787 67.793 50.419 9.756 102.781 5.239 150.474-12.974 47.685-18.212 88.555-49.313 117.441-89.352 28.89-40.047 44.49-87.253 44.83-135.628.24-32.133-6.26-63.982-19.14-93.749-12.86-29.758-31.84-56.849-55.847-79.717-24.011-22.867-52.572-41.071-84.059-53.563-31.495-12.492-65.289-19.03-99.474-19.245z",
  fill: "url(#left-8-black_svg__paint0_linear_402_774)",
  fillOpacity: 0.25
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "left-8-black_svg__paint0_linear_402_774",
  x1: 139.5,
  y1: 1785.43,
  x2: 1112.38,
  y2: 801.583,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3371EF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#750B00"
})));

var SvgLeft8Black = function SvgLeft8Black(props) {
  return React.createElement("svg", _extends({
    width: 1628,
    height: 2379,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/left-8-black.472a3655.svg";
export { SvgLeft8Black as ReactComponent };